export const GET_EVENTS_LEADERBOARD_LIST ="GET_EVENTS_LEADERBOARD_LIST";
export const SET_CURRENT_QUES_ID ="SET_CURRENT_QUES_ID";
export const GET_QUES_LEADERBOARD_LIST ="GET_QUES_LEADERBOARD_LIST";
export const SET_LEADERBOARD_LIST ="SET_QUES_LEADERBOARD_LIST";
export const SET_EDIT_LEADER_BOARD_LIST ="SET_EDIT_LEADER_BOARD_LIST";
export const SET_LEADERBOARD_EVENTS ="SET_LEADERBOARD_EVENTS";
export const SET_LEADERBOARD_QUESTIONS ="SET_LEADERBOARD_QUESTIONS";
export const SET_EDIT_LEADER_BOARD_QUESTION_DATA ="SET_EDIT_LEADER_BOARD_QUESTION_DATA";
export const SET_DROPDOWN_QUESTIONS_LIST ="SET_DROPDOWN_QUESTIONS_LIST";
export const SET_IS_GET_EVENTS_LEADERBOARD_LISTS_PENDING= "SET_IS_GET_EVENTS_LEADERBOARD_LISTS_PENDING";
export const SET_IS_GET_QUESTIONS_LEADERBOARD_LISTS_PENDING= "SET_IS_GET_QUESTIONS_LEADERBOARD_LISTS_PENDING";
export const SET_IS_GET_DROPDOWN_QUESTIONS_LIST_PENDING= "SET_IS_GET_DROPDOWN_QUESTIONS_LIST_PENDING";
export const SET_CONTINOUS_EVALUATE_PENDING = "SET_CONTINOUS_EVALUATE_PENDING";
export const SET_IS_EDIT_LEADERBOARD_PENDING = "SET_IS_EDIT_LEADERBOARD_PENDING";
export const SET_LOCK_EDITING_PENDING = "SET_LOCK_EDITING_PENDING";
export const SET_CURRENT_QUESTION_ID = "SET_CURRENT_QUESTION_ID";
export const SET_UNLOCK_EDITING_PENDING = "SET_UNLOCK_EDITING_PENDING";
export const SET_LEADERBOARD_SORT = "SET_LEADERBOARD_SORT";
export const SET_LEADERBOARD_QUESTION_SORT = "SET_LEADERBOARD_QUESTION_SORT";
export const IS_OPEN_PLAYER_MODEL = "IS_OPEN_PLAYER_MODEL";
export const SET_LB_EXECUTE_PENDING = "SET_LB_EXECUTE_PENDING";
export const SET_LEADERBOARD_GAME_DATA = "SET_LEADERBOARD_GAME_DATA";
export const SET_OPPONENT_PLAYER_LIST = "SET_OPPONENT_PLAYER_LIST";
export const SET_LB_PLAYER2 = "SET_LB_PLAYER2";
export const SET_PLAY_LB_GAME = "SET_PLAY_LB_GAME";
export const SET_EVALUATE_ISGAME = "SET_EVALUATE_ISGAME";
export const SET_GAME_LEADERBOARD = "SET_GAME_LEADERBOARD";
export const SET_EVALUATE_EVENTID = "SET_EVALUATE_EVENTID";
export const SET_LB_PLAYER1 = "SET_LB_PLAYER1";
export const OPEN_POINTS_TABLE = "OPEN_POINTS_TABLE";
export const SET_POINTS_TABLE_PENDING = "SET_POINTS_TABLE_PENDING";
export const SET_POINTS_TABLE_DATA = "SET_POINTS_TABLE_DATA";
export const SET_LB_UPDATED_TIME = "SET_LB_UPDATED_TIME";
